import React from 'react';

export const LogoMark = ({ size = 36, className = '' }) => (
  <svg viewBox="85 85 130 120" width={size} height={size * (120/130)} className={className} xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
    <defs>
      <linearGradient id="smGold1" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#ffeabf" />
        <stop offset="100%" stopColor="#c3a66d" />
      </linearGradient>
    </defs>
    <g>
      <path d="M145.95,149.37c1.93,0.69 3.45,2.21 4.14,4.13c0.69,-1.92 2.22,-3.44 4.14,-4.12c-1.94,-0.69 -3.47,-2.22 -4.15,-4.15c-0.68,1.92 -2.2,3.45 -4.13,4.14Z" fill="url(#smGold1)"/>
      <path d="M115.06,136.21c3.19,2 6.66,3.8 9.32,5.73c4.68,2.95 7.94,7.96 8.5,13.76c0.24,1.3 0.24,2.09 0.24,2.09c3.28,-13.5 -6.95,-25.65 -6.95,-25.65c18.34,12.8 9.36,37.29 9.36,37.29c0,0 -4.49,11.04 -13.96,17.6c0,0 6.65,-7.54 9.62,-16.27c-17.23,6.53 -19.73,24.43 -20.09,28.94c19.73,-7.22 33.81,-26.16 33.81,-48.38c0,-26.05 -19.35,-47.57 -44.47,-51.01c0,16.57 3.35,28.82 14.62,35.9Z" fill="url(#smGold1)"/>
      <path d="M155.27,151.31c0,22.23 14.08,41.17 33.8,48.38c-0.35,-4.51 -2.85,-22.41 -20.08,-28.94c2.97,8.73 9.61,16.27 9.61,16.27c-9.46,-6.56 -13.96,-17.6 -13.96,-17.6c0,0 -8.98,-24.49 9.36,-37.29c0,0 -10.22,12.15 -6.95,25.65c0,0 0.01,-0.79 0.25,-2.09c0.56,-5.8 3.81,-10.81 8.5,-13.76c2.66,-1.93 6.13,-3.73 9.32,-5.73c11.27,-7.08 14.61,-19.33 14.61,-35.9c-25.11,3.43 -44.46,24.95 -44.46,51.01Z" fill="url(#smGold1)"/>
    </g>
  </svg>
);

export const Logo = ({ dark = false, size = 'md' }) => {
  const sizes = { sm: { mark: 26, text: 'text-sm tracking-[0.32em]' }, md: { mark: 34, text: 'text-[13px] tracking-[0.34em]' }, lg: { mark: 48, text: 'text-base tracking-[0.4em]' } };
  const s = sizes[size];
  return (
    <div className="flex items-center gap-3">
      <LogoMark size={s.mark} />
      <div className="leading-tight">
        <div className={`${s.text} uppercase font-serif font-medium ${dark ? 'text-[#faf4ea]' : 'text-[#053e49]'}`} style={{ letterSpacing: '0.32em' }}>SUNDAY</div>
        <div className={`${s.text} uppercase font-serif font-medium ${dark ? 'text-[#c3a66d]' : 'text-[#c3a66d]'}`} style={{ letterSpacing: '0.32em' }}>MIRROR</div>
      </div>
    </div>
  );
};

export default Logo;
